/**
 * UI控件库 
 * @module UI
 */
;(function (ui) {
    /**
     * <h3>上拉菜单 actionsheet</h3>
     * <a href="../../ui_controls/bui.actionsheet.html" target="_blank">demo</a>
     * <p></p>
     * <h5>方法</h5>
     * {{#crossLink "bui.actionsheet/option"}}{{/crossLink}}: 获取设置参数 <br>
     * {{#crossLink "bui.actionsheet/widget"}}{{/crossLink}}: 获取依赖控件 <br>
     * {{#crossLink "bui.actionsheet/hide"}}{{/crossLink}}: 隐藏二级菜单 <br>
     * {{#crossLink "bui.actionsheet/show"}}{{/crossLink}}: 显示二级菜单 <br>
     *  @namespace bui
     *  @class actionsheet
     *  @constructor 
     *  @param {object} option  
     *  @param {array}  option.buttons [ 有多少个按钮 ]  
     *  @param {string} [option.trigger] [ 触发按钮的id ]  
     *  @param {string} [option.handle] [ 点击上面的按钮 ]  
     *  @param {string} [option.position] [ 位置 bottom || top ]   
     *  @param {number} [option.width] [ 0 为自适应 ]  
     *  @param {boolean} [option.mask] [ 是否显示遮罩 ]  
     *  @param {string} [option.cancelText] [ 取消的文本, 为空则不显示 ]  
     *  @param {function} [option.callback] [ 点击按钮的回调 ]  
     *  @example
     * 
     *   html:
     *
            <div id="btnOpen" class="bui-btn">actionsheet</div>
     *      
     *   js: 
     *   
            // 初始化
            var uiActionsheet = bui.actionsheet({
                trigger: "#btnOpen",
                buttons: [{ name:"分享到微博",value:"weibo" },{ name:"分享到微信",value:"weixin" }],
                callback: function (e,ui) {
                    
                    var val = $(this).attr("value");

                    console.log(val);
                    if( val == "cancel"){
                        ui.hide();
                    }
                }
            })
     *
     *
     */
    ui.actionsheet = function(option){
        
        //默认配置
        var config = {
            appendTo:"body",
            trigger: "",             
            handle: ".bui-btn",
            position:"bottom",
            width: 0,
            mask: true,
            buttons: [],
            cancelText: "取消",
            callback: null
        }

        //方法
        var module = {
            hide: hide,
            show: show,
            widget: widget,
            option: options,
            config: param,
            init: init
        };
        //用于option方法的设置参数
        var param = module.config = $.extend(false,{}, config, ui.config.actionsheet, option );

        var id ,
            uiDialog,
            $trigger,
            gid,
            $id;
        
        //执行初始化
        init(param);

        //初始化
        function init (option) {
            option = option || param;
            
            $trigger = ui.obj(option.trigger);
            //option获取新参数使用
            param = module.config = option;
            
            gid = ui.guid();

            var html = template(option.buttons);

            $(option.appendTo).append(html);

            //对话框初始化
            uiDialog = ui.dialog({
                id: gid,
                position: option.position,
                mask: option.mask,
                onMask: function (argument) {
                    hide();
                }
            });

            $id = ui.obj(gid);
            $handle = $id.find( option.handle ) ;

            bind();

           return this;
        }

        // 事件绑定
        function bind() {
            param.callback && $handle.off("click.bui").on("click.bui",function (e) {
                param.callback.call(this,e,module);
            });

            $trigger && $trigger.off("click.bui").on("click.bui",function (argument) {
                show();
            })
        }

        //按钮模板生成器
        function template(data) {
            
            var width = parseFloat(param.width);
            var cssStyle = width>0 ? 'width:'+width+'px;left:50%;right:0;margin-left:-'+width/2+'px;': '';
            
            var html = '';
            if( data && data.length ){
                    html +='<div id="'+gid+'" class="bui-actionsheet" style="'+cssStyle+'">';
                    html +='    <ul class="bui-list">';
                $(data).each(function(i,item) {
                    html +='        <li class="bui-btn '+(item.className || '')+'" value="'+(item.value || '')+'">'+( item.name || "" )+'</li>';
                })
                    html +='    </ul>';
                    param.cancelText ? html +='    <div class="bui-btn" value="cancel">'+param.cancelText+'</div>': '';
                    html +='</div>';
            }

            return html;
        }
        /**
         * 隐藏菜单
         *  @method hide
         *  @example 
            
            //隐藏菜单
            uiActionsheet.hide();
                
         */
        function hide(callback) {

             uiDialog.isOpen() && uiDialog.close(callback);
        }
        /**
         * 显示菜单
         *  @method show
         *  @example 
            
            //显示菜单
            uiActionsheet.show();
                
         */
        function show(callback) {
            !uiDialog.isOpen() && uiDialog.open(callback);
        }

        /**
         * 获取依赖的控件
         *  @method widget
         *  @param {string} [name] [ 依赖控件名 ]
         *  @example 
            
            //获取依赖控件
            var uiActionsheetWidget = uiDropdown.widget();
            
                
         */
        function widget(name) {
            var control = { dialog: uiDialog };
            return ui.widget.call(control,name);
        };
        /**
         * 获取设置参数
         *  @method option
         *  @param { string | object } [key] [ 不传则获取所有参数, 类型为string,没有第2个参数则获取某个参数 ]
         *  @param { string | number | boolean | function } [value] [ 设置参数的时候要传,设置多个参数不用传,获取参数的时候也不用传 ]
         *  @chainable
         *  @example 
            
            
            //获取所有参数
            var option = uiActionsheet.option();

            //获取某个参数
            var id = uiActionsheet.option( "trigger" );

            //修改一个参数
            uiActionsheet.option( "width",200 );

            //修改多个参数
            uiActionsheet.option( {"width":200} );
                
         */
        function options (key,value) {

           return ui.option.call(module,key,value);
        }

        return module;

    };

    return ui;

})( bui || {} );
